import React from 'react';
import { Segment, Button, Icon } from 'semantic-ui-react';
import { isEmpty, startCase } from 'lodash';

export const section = (label = '', value = '') => (
  <div className="detail-column" key={label}>
    <div className="detail-item">
      <p className="detail-title">{startCase(label)}</p>
      <div className="detail-text">{value || '—'}</div>
    </div>
  </div>
);

export const label = (label = '', value = '', index) => (
  <div className="label-item" key={index}>
    <Icon
      name={value ? 'check' : 'close'}
      color={value ? 'green' : 'red'}
      key={label}
    />
    <span className="label-title">{startCase(label)}</span>
  </div>
);

const mapItemToSection = (item) =>
  Object.keys(item).map((key) => section(key, item[key]));

const DetailsHeader = ({
  compact = false,
  item = {},
  editable = false,
  onEdit,
  labels,
  Component = null,
  loading,
  className,
  isReadOnlyRole,
}) => (
  <Segment loading={loading} className={className} compact={compact}>
    <div className="details-header">
      <div className="label-segment">
        {labels &&
          Object.keys(labels).map((key, index) =>
            label(key, labels[key], index),
          )}
      </div>
      {editable && (
        <Button
          onClick={onEdit}
          disabled={isReadOnlyRole}
          content="Edit"
          floated="right"
        />
      )}
    </div>
    {/* Support either a single object or array of objects (for multiple sections) */}
    {Array.isArray(item) ? (
      item.map(
        (subItem, index) =>
          !isEmpty(subItem) && (
            <div className="detail-segment" key={index}>
              {mapItemToSection(subItem)}
            </div>
          ),
      )
    ) : (
      <div className="detail-segment">{mapItemToSection(item)}</div>
    )}
    {Component}
  </Segment>
);

export default DetailsHeader;
